__turbopack_context__.v({
  "hiddenAll": "StoriesList-module-scss-module__1NFEGq__hiddenAll",
  "hiddenMobileOnly": "StoriesList-module-scss-module__1NFEGq__hiddenMobileOnly",
  "item": "StoriesList-module-scss-module__1NFEGq__item",
  "latestStories": "StoriesList-module-scss-module__1NFEGq__latestStories",
  "revealReady": "StoriesList-module-scss-module__1NFEGq__revealReady",
  "revealed": "StoriesList-module-scss-module__1NFEGq__revealed",
  "root": "StoriesList-module-scss-module__1NFEGq__root",
  "seeMoreMobileOnly": "StoriesList-module-scss-module__1NFEGq__seeMoreMobileOnly",
  "seeMoreWrapper": "StoriesList-module-scss-module__1NFEGq__seeMoreWrapper",
  "title": "StoriesList-module-scss-module__1NFEGq__title",
});
